export default {
  sections: {
    asap_orders: {
      title: 'Heti-tilaukset',
      fields: {
        has_live_orders: {
          label: 'Tilaukset käytössä',
          tooltip: 'Ota tämä käyttöön vasta, kun ravintola julkaistaan ja alkaa vastaanottaa tilauksia',
        },
        has_asap_orders: {
          label: 'Sallitaanko asiakkaiden tehdä heti-tilauksia?',
          tooltip: '*Heti-tilaukset perustuvat valmistusaikaasi',
        },
      },
    },
    scheduled_orders: {
      title: 'Ajastetut tilaukset',
      fields: {
        has_scheduled_orders: {
          label: 'Sallitaanko asiakkaiden tilata etukäteen tietylle ajalle?',
        },
        has_pre_order: {
          label: 'Sallitaanko asiakkaiden tilata yli yhden päivän etukäteen?',
        },
        max_pre_order_days: {
          label: 'Enimmäispäivät etukäteistilauksille',
          placeholder: '14',
        },
        has_scheduled_order_reminders: {
          label: 'Ajastettujen tilausten muistutusilmoitukset',
        },
        scheduled_orders_time_slot_interval: {
          label: 'Aikavälit minuuteissa',
          option: '{{value}} minuutin aikaväli',
        },
        has_scheduled_orders_time_slot_order_limit: {
          label: 'Lisää enimmäistilausmäärä aikaväliä kohden',
        },
        scheduled_orders_time_slot_order_limit: {
          label: 'Enimmäistilausmäärä aikaväliä kohden',
          placeholder: '5',
        },
        order_instructions_title: {
          label: 'Tilausohjeet',
          placeholder: 'Kirjoita tilausohjeet',
        },
        scheduled_order_option_title: {
          label: 'Ajasta myöhemmäksi -vaihtoehdon otsikko',
          placeholder: 'Ajasta myöhemmäksi',
        },
      },
    },
    other: {
      title: 'Muut',
      fields: {
        order_approval_time_step: {
          label: 'Vahvistetun tilausajan lisääminen / vähentäminen',
          option: '{{value}} min',
        },
        order_confirmation_time_extra_minutes: {
          label: 'Lisäminuuttien lisääminen vahvistettuun aikaan',
          option: '{{value}} min',
        },
      },
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  feedback: {
    restaurant_suspended: {
      title: 'Tämä ravintola on keskeytetty',
      description:
        'Jotta voit julkaista ravintolan uudelleen, siirry <a>tilaussivulle</a> ja aktivoi ravintola uudelleen. Sen jälkeen voit ottaa tilaukset käyttöön tällä sivulla.',
    },
  },
  toasts: {
    at_least_one_order_method_required:
      'Vähintään yhden tilaustavan (ajastettu tai heti) on oltava käytössä. Et voi poistaa molempia käytöstä.',
  },
};
